import axios from "axios";
import { ExpiredTime, price_stock_analysis } from "constants/configLocalStorage";
import { checkTimeOutData, getUrlPriceLink } from "Helpers/helpFunction";
import { axiosGET } from "Helpers/TypeAxios";
import moment from "moment";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "service/API";
import { historyProps } from "service/API/Chart";
import { setChartAnalysisData, setDatafeedInstruments, setStockInformation, setValues, setValuesValuation } from "store/actionReducers/ChartStore";
import { setPriceStockAnalysis } from "store/actionReducers/StocksAnalysisStore";

export default function useChart() {
  const dispatch = useDispatch();
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const ChartStore = useSelector((state: any) => state?.ChartStore)

  const fetchChart = useCallback(async ({ resolution, symbol, from, to }: historyProps) => {
    if (symbol) {
      const res = await API.Chart.history({ resolution, symbol, from, to });
      if (res?.t?.length > 0) {
        fetchPriceStockAnalysis(symbol, res)
        dispatch(setChartAnalysisData(res))
      } else {
        dispatch(setChartAnalysisData({}))
      }

    }
  }, []);

  const fetchPriceStockAnalysis = (symbol: string, ChartStore: any) => {
    const length = ChartStore?.['c']?.length - 1 || 0
    const time = length ? ChartStore?.['t'][length] : 0
    const volumn = length ? ChartStore?.['v'][length] : 0
    const priceOpen = length ? ChartStore?.['o'][length] : 0
    const priceClose = length ? ChartStore?.['c'][length] : 0
    const value = {
      time: parseFloat(time),
      volumn: parseFloat(volumn),
      priceOpen: parseFloat(priceOpen),
      priceClose: parseFloat(priceClose),
    }
    const priceStore: any = localStorage.getItem(price_stock_analysis)
    const checkTime = checkTimeOutData(priceStore);
    let listStockOld: any = checkTime?.data || {};
    listStockOld[symbol] = value
    const timeLocal = moment().add(ExpiredTime, 'minutes').valueOf()
    localStorage.setItem(price_stock_analysis, JSON.stringify({ time: timeLocal, data: listStockOld }))
    dispatch(setPriceStockAnalysis(listStockOld))
  }

  const makePrice = useCallback((priceOpen: number, priceClose: number) => {
    const PriceVolatility = (priceClose - priceOpen)
    const PercentPriceVolatility = priceOpen ? (((priceClose - priceOpen) / priceOpen) * 100) : 0;
    return {
      PriceVolatility,
      PercentPriceVolatility
    }
  }, [])

  const fetchDataFeedInstruments = useCallback(async () => {
    const res = await axios(getUrlPriceLink())
    if (res?.status === 200) {
      if (res?.data?.s === 'ok') {
        dispatch(setDatafeedInstruments(res?.data?.d))
      }
    }
  }, [])

  const filterStock = useCallback(() => {
    if (StocksAnalysisStore?.inputSearch) {
      if (ChartStore?.datafeedInstruments.length > 0) {
        const stockFilter = ChartStore?.datafeedInstruments.filter((item: any) => {
          if (item?.symbol === StocksAnalysisStore?.inputSearch) {
            return item
          }
        })
        if (stockFilter.length > 0) {
          dispatch(setStockInformation(stockFilter?.[0]))
        }
      }
    }
  }, [StocksAnalysisStore?.inputSearch, ChartStore?.datafeedInstruments])

  const fetchValue = useCallback(async (data: any) => {
    if (data?.ticker) {
      const res = await API.Chart.values(data);

      if (res?.code === '0') {
        dispatch(setValues(res?.data))
      }
    }

  }, [])

  const fetchValueValuation = useCallback(async (data: any) => {
    if (data?.ticker) {
      const res = await API.Chart.valuesValuation(data);
      if (res?.code === '0') {
        dispatch(setValuesValuation(res?.data))
      }
    }
  }, [])

  return { fetchChart, makePrice, fetchDataFeedInstruments, filterStock, fetchValue, fetchValueValuation }
}